import React from "react";
import {Dialog} from "@mui/material";
import PropTypes from "prop-types";
import {CloseIcon, DialogContent, GotItButton, StampWrapper, Wrapper} from "./styles";
import close from '../../../../assets/images/reservation/close.svg';
import {useTranslation} from "react-i18next";
import {Trans} from 'react-i18next'
import {Stamp} from "../Stamp";

const InstantBookingInfoDialog = props => {
    const {open, onClose, variant, diff, restriction, marina} = props;
    const {t} = useTranslation();

    return <Dialog open={open} onClose={onClose} maxWidth="lg" PaperProps={{
        style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            boxSizing: 'border-box'
        },
    }}>
        <Wrapper>
            <CloseIcon src={close} onClick={onClose}/>
            <StampWrapper>
                <Stamp/>
            </StampWrapper>
            <DialogContent>
                <span className="bold">
                    {t(variant === 'toolate' ? 'INSTANT_BOOKING_INFO_TOO_LATE_ROW_1' : (variant === 'size' ? 'INSTANT_BOOKING_INFO_SIZE_ROW_1' : 'INSTANT_BOOKING_INFO_ROW_1'))}
                </span>
                <br/>
                <ul>
                    <li>
                        {variant === 'general' &&
                            <Trans i18nKey="INSTANT_BOOKING_INFO_ROW_2">
                                If boat details and required dates meet the instant booking availability, you will be
                                offered to <strong>book instantly</strong>, pay with a credit card and receive immediate
                                confirmation.
                            </Trans>
                        }
                        {variant === 'unavailable' &&
                            <Trans i18nKey="INSTANT_BOOKING_UNAVAILABLE_INFO_ROW_2">
                                If boat details and required dates meet the instant booking availability, you will be
                                offered to <strong>book instantly</strong>, pay with a credit card and receive immediate
                                confirmation.
                            </Trans>
                        }
                        {variant === 'toolate' && diff !== undefined && restriction !== undefined &&
                            <>
                                {((marina?.id === 82 && process.env.REACT_APP_FIREBASE_ENV === "PRODUCTION")
                                    || (marina?.id === 411 && process.env.REACT_APP_FIREBASE_ENV === "TEST")) ? t('INSTANT_BOOKING_INFO_TOO_LATE_LAGOS_1') : (
                                    diff === 1 && restriction === 1 ? t('INSTANT_BOOKING_INFO_TOO_LATE_ROW_2_DAY_DAY', {
                                            needed: diff,
                                            restriction
                                        }) :
                                        diff > 1 && restriction === 1 ? t('INSTANT_BOOKING_INFO_TOO_LATE_ROW_2_DAYS_DAY', {
                                                needed: diff,
                                                restriction
                                            }) :
                                            diff === 1 && restriction > 1 ? t('INSTANT_BOOKING_INFO_TOO_LATE_ROW_2_DAY_DAYS', {
                                                    needed: diff,
                                                    restriction
                                                }) :
                                                diff > 1 && restriction > 1 ? t('INSTANT_BOOKING_INFO_TOO_LATE_ROW_2_DAYS_DAYS', {
                                                        needed: diff,
                                                        restriction
                                                    }) :
                                                    diff === 0 && restriction === 1 ? t('INSTANT_BOOKING_INFO_TOO_LATE_ROW_2_TODAY_DAY', {restriction}) :
                                                        diff === 0 && restriction > 1 ? t('INSTANT_BOOKING_INFO_TOO_LATE_ROW_2_TODAY_DAYS', {restriction}) : null
                                )}

                            </>
                        }
                        {variant === 'size' &&
                            <Trans i18nKey="INSTANT_BOOKING_INFO_SIZE_ROW_2">
                                The marina has specific berths allocated for instant booking. Your boat exceeds the size
                                of those berths and therefore you cannot <strong>book instantly</strong>
                            </Trans>
                        }
                    </li>
                    <br/>
                    <li>
                        {variant === 'general' &&
                            <Trans i18nKey="INSTANT_BOOKING_INFO_ROW_3">
                                Otherwise you will be redirected to <strong>submit a booking request</strong> and the
                                marina will get back to you shortly.
                            </Trans>
                        }
                        {variant === 'unavailable' &&
                            <Trans i18nKey="INSTANT_BOOKING_UNAVAILABLE_INFO_ROW_3">
                                Otherwise you will be redirected to <strong>submit a booking request</strong> and the
                                marina will get back to you shortly.
                            </Trans>
                        }
                        {variant === 'toolate' ? (((marina?.id === 82 && process.env.REACT_APP_FIREBASE_ENV === "PRODUCTION")
                            || (marina?.id === 411 && process.env.REACT_APP_FIREBASE_ENV === "TEST")) ? (restriction === 1 ?
                                t('INSTANT_BOOKING_INFO_TOO_LATE_LAGOS_2_1DAY', {restriction}) : t('INSTANT_BOOKING_INFO_TOO_LATE_LAGOS_2', {restriction})) :
                            <Trans i18nKey="INSTANT_BOOKING_INFO_TOO_LATE_ROW_3">
                                Otherwise you will be redirected to <strong>submit a booking request</strong> and the
                                marina will get back to you shortly.
                            </Trans>) : null
                        }
                        {variant === 'size' &&
                            <Trans i18nKey="INSTANT_BOOKING_INFO_TOO_LATE_SIZE_ROW_3">
                                Otherwise you will be redirected to <strong>submit a booking request</strong> and the
                                marina will get back to you shortly.
                            </Trans>
                        }
                    </li>
                </ul>
                <GotItButton onClick={onClose}>{t('GOT_IT')}</GotItButton>
            </DialogContent>
        </Wrapper>
    </Dialog>
}

InstantBookingInfoDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['general', 'unavailable', 'toolate', 'size']),
    diff: PropTypes.number,
    restriction: PropTypes.number,
    marina: PropTypes.object
}

export default InstantBookingInfoDialog;
